// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__UxwXi","spinner":"Loading_spinner__GHdNV","spin":"Loading_spin__Slmpr","hidden":"Loading_hidden__lo4UK"};